import { render, staticRenderFns } from "./SaveUserButton.vue?vue&type=template&id=0facb64c&scoped=true"
import script from "./SaveUserButton.vue?vue&type=script&lang=js"
export * from "./SaveUserButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0facb64c",
  null
  
)

export default component.exports